import { useNavigate } from "react-router-dom";
import ThemeConstants from "../../../../config/theme/theme_constants";
import { NewsInterface } from "../domain/interfaces/news_interface";
import ReactMarkdown from "react-markdown";
import NewsArrowIcon from '../../../../assets/images/news_arrow_icon.svg?react';
import { useTranslation } from "../../../../i18n/useTranslation";

interface NewsElementProps {
    className?: string;
    news: NewsInterface;
}

const NewsElement: React.FC<NewsElementProps> = ({ className, news }) => {
    const { t } = useTranslation();
    const theme = ThemeConstants();
    const navigate = useNavigate();
    return (
        <button
            className={`relative rounded-[30px] h-84.25 text-white ${className} cursor-pointer bg-white flex flex-col justify-between`}
            style={{ boxShadow: '0 0 4px rgba(0,0,0,0.04), 0 8px 16px rgba(0,0,0,0.08)' }}
            onClick={() => navigate(`/news/${news.id}`, { state: { news } })}
        >
            {news.picture && <img src={news.picture} alt={t('news.image_alt', { title: news.title })} className="absolute w-full h-full rounded-[30px] object-cover z-0" draggable={false}/>}
            <p className="rounded-[30px] px-4 py-2.5 mx-5 mt-5 w-fit z-1 text-left leading-tight" style={{ backgroundColor: theme.UvibesPink }}>{news.title}</p>
            <div className="w-full flex flex-col items-start rounded-b-[30px] py-3 gap-1.25 pl-5 pr-3 z-1" style={{ backgroundColor: theme.UvibesPink }}>
                <div className="text-xs pr-0.75 font-medium line-clamp-2 overflow-ellipsis leading-relaxed min-h-8 text-left"><ReactMarkdown>{news.text}</ReactMarkdown></div>
                <div className="flex justify-between items-center w-full">
                    <p className="text-xs font-light pt-px">{t('news.reading_time', { time: news.readingTime })}</p>
                    <NewsArrowIcon width={24} height={24} />
                </div>
            </div>
        </button>
    )
}

export default NewsElement;